module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_header-e5ea7a1839da794e1c230c40fdd864dd.webp";